import React from 'react';
import cx from 'classnames';
import { ErrorTextProps } from './InputField.types';
import styles from './InputField.module.scss';

const ErrorText = ({ children, className, ...rest }: ErrorTextProps) => (
  <div className={cx(styles.errorText, className)} data-cy='ErrorText' {...rest} aria-live='polite'>
    {children}
  </div>
);

export default ErrorText;
